













import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace, State, Action, Mutation } from 'vuex-class';
import Popup from './Popup.vue';
import { isWeiXin } from '@/common/ts/common';
import { Dialog, Toast } from 'vant';
// 投票接口
import {
  vote,
  balance,
  userInfo,
  baseInfo,
  MAX_VOTE_NUM,
  STOR_NAME,
} from '../api/index';
import { UPDATE_BALANCE } from '../store/mutation-types';

import { getLocalTime, nowInDateBetwen } from '../util/index';

import EventsBus from '../bus';

const Modules = namespace(STOR_NAME);
Vue.use(Dialog);
@Component({
  components: {
    Popup,
  },
})
export default class LikeButton extends Vue {
  @Modules.State('userInfo') userInfo!: any;
  @Modules.State('balanceC') balanceC!: any;
  @Modules.Mutation UPDATE_VOTE_NUM!: (num: any) => void;
  @Modules.Mutation UPDATE_BALANCE!: (num: any) => void;
  @Modules.Action fetchUserInfo!: () => void;
  @Modules.Action fetchBalance!: () => void;
  @Prop() voteId!: string | number;
  @Prop({ default: 'small' }) size!: string;
  @Prop() startTime!: string;
  @Prop() endTime!: string;

  popupShowVal = false;
  voteNum: string | number = 0;
  isInTheVote: boolean = false;
  downLoadUrl =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  pointOut = false;

  created() {
    window.userInfoChange = () => {
      this.$router.go(0);
      this.fetchUserInfo();
      this.fetchBalance();
    };
  }

  async handleClickBtn() {
    // 判断是不是在10月8日10：00——10月15日18：00
    // const isInVoteTime: any = nowInDateBetwen(getLocalTime(this.startTime), getLocalTime(this.endTime));
    // if (isInVoteTime.toString() !== 'true') {
    //   Toast.fail(isInVoteTime);
    //   return;
    // }
    // 判断是否在app内
    if (!window.udid) {
      this.isNotInApp();
      return;
    }
    // 判断是否登陆
    const isLogin = await this.judgeIsLogin();
    if (!isLogin) {
      console.log('登录状态' + isLogin);
      return;
    }
    // 判断余额为0时提示去充值
    const isBalance = await this.judgeBalance();
    if (!isBalance) {
      console.log('余额为0？' + isBalance);
      return;
    }
    this.popupShowVal = true;
  }

  // 点赞弹出框取消事件
  handleClickCancel(e: any) {
    this.popupShowVal = false;
  }
  // 点赞弹出框确认事件
  handleClickConfirm(e: any) {
    if (!this.isInTheVote) {
      this.voteNum = e;
      this.startVote();
    }
  }

  startVote() {
    this.inAppVote().then((res: any) => {
      this.successVote(res);
    });
  }
  // 判断在APP内投票处理函数
  async inAppVote() {
    // 判断输入的投票数量
    if (!this.judgeVoteNum()) {
      return;
    }
    this.isInTheVote = true;
    const data = {
      id: this.voteId,
      num: Number(this.voteNum),
    };
    const res = await vote(data);
    return res;
  }

  // 判断不在APP内处理函数
  isNotInApp() {
    Dialog.confirm({
      title: '友情提示',
      message: '请在上游新闻App进行投票',
      confirmButtonText: '还没装？一步安装',
      cancelButtonText: '我已安装过',
      closeOnClickOverlay: true,
    })
      .then(() => {
        window.location.href = this.downLoadUrl;
      })
      .catch(() => {
        if (isWeiXin() === true) {
          this.pointOut = true;
        } else {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        }
      });
  }
  // 判断是否登陆
  async judgeIsLogin() {
    const token = window.gettoken();
    if (token && token !== 'null') {
      return true;
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return false;
    }
  }
  // 判断余额为0时，提示去充值
  async judgeBalance() {
    await this.fetchBalance();
    if (Number(this.balanceC) === 0) {
      Dialog.confirm({
        title: '温馨提示',
        message: '余额不足，请先充值',
        confirmButtonText: '去充值',
      })
        .then(() => {
          // on confirm
          this.$router.push({
            name: 'CQYScoin-record',
          });
        })
        .catch(() => {
          // on cancel
        });
      return false;
    }
    return true;
  }
  // 判断输入的投票数量
  judgeVoteNum() {
    const voteCount = Number(this.voteNum);
    const assets = Number(this.balanceC);
    const ERROR_MSG = `请输入正整数，最小值为1，最大值为${MAX_VOTE_NUM}`;
    if (!voteCount) {
      // 没有输入或者输入为0时
      Dialog.alert({
        message: '请输入正确的投票数！',
      });
      return false;
    } else if (voteCount > assets) {
      // 余额不足时
      Dialog.alert({
        message: '余额不足，请重新输入',
      });
      return false;
    } else if (voteCount.toString().indexOf('.') > -1) {
      // 输入带有小数点时
      Dialog.alert({
        message: ERROR_MSG,
      });
      return false;
    } else if (voteCount.toString().indexOf('-') > -1) {
      // 输入为负数时
      Dialog.alert({
        message: ERROR_MSG,
      });
      return false;
    } else if (voteCount.toString()[0] === '0') {
      // 输入的投票数为0开头
      Dialog.alert({
        message: ERROR_MSG,
      });
      return false;
    } else if (Number(voteCount) > MAX_VOTE_NUM) {
      Dialog.alert({
        message: ERROR_MSG,
      });
      return false;
    }
    return true;
  }
  successVote(res: any) {
    if (res.msg === '投票成功') {
      Toast.success('点赞成功');
      this.UPDATE_VOTE_NUM(res.data);
      this.notifyList(res);
      this.updateBalance();
      this.popupShowVal = false;
      this.isInTheVote = false;
    } else {
      Toast.fail(res.msg);
      this.isInTheVote = false;
    }
  }
  // 投票成功后余额接口修改
  async updateBalance() {
    const res: any = await balance();
    if (res.code === 200) {
      this.UPDATE_BALANCE(res.data);
    }
  }
  // 通知list页面修改数据
  notifyList(res: any) {
    EventsBus.$emit('AfterVote', {
      voteId: this.voteId,
      data: res.data,
    });
  }
}
